"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const login2FASelector_1 = require("../selectors/login2FASelector");
const types_1 = require("../types");
const login2FAAction_1 = require("../actions/login2FAAction");
const react_intl_1 = require("react-intl");
const CommonErrorStyle_1 = __importDefault(require("@/features/transaction-signing/containers/styles/CommonErrorStyle"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const material_1 = require("@mui/material");
const LostOrChanged = () => {
    const classes3 = (0, CommonErrorStyle_1.default)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { layoutStatus } = (0, react_redux_1.useSelector)(login2FASelector_1.login2FASelector);
    const handleToggleCloseLostOrChanged = () => {
        console.log('handleToggleCloseLostOrChanged');
        dispatch((0, login2FAAction_1.toggleCloseLostOrChanged)());
    };
    return (react_1.default.createElement(Dialog_1.default, { open: layoutStatus === types_1.LayoutStatus.LOST_OR_CHANGED, classes: { paper: classes3.dialog }, TransitionComponent: material_1.Slide, onClose: () => console.log('dismiss') },
        react_1.default.createElement("div", { style: {
                font: '13px/1.231 arial,helvetica,clean,sans-serif',
                width: '330px',
                height: '192px',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                background: '#f7f7f7',
                padding: '10px'
            } },
            react_1.default.createElement("h3", { className: classes3.lostOrChanged_Title },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-lost-or-changed-title" })),
            react_1.default.createElement("div", { className: classes3.lostOrChanged_Content },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-lost-or-changed-content-1", values: {
                        strongNumber: react_1.default.createElement("strong", null, "new mobile phone")
                    } }),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-lost-or-changed-content-2" })),
            react_1.default.createElement(material_1.Button, { className: classes3.OK, name: "OK", disableTouchRipple: true, disableFocusRipple: true, onClick: handleToggleCloseLostOrChanged },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-lost-or-changed-btn" })))));
};
exports.default = LostOrChanged;
